// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderResultSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderResultSearchDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1CardFinderResultSearchDefaultResponseData.discriminator = undefined;
PharmacyV1CardFinderResultSearchDefaultResponseData.additionalProperties = false;
PharmacyV1CardFinderResultSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "results",
        "baseName": "results",
        "type": ""
    },
];
//# sourceMappingURL=pharmacyV1CardFinderResultSearchDefaultResponseData.js.map